import { type ValueOf } from '@/types';
import { type TimeOffDuration } from './constants';
import {
	type TimeOff,
	type TimeOffListPopoverQuery,
} from '@/generated/graphql';
import { type SuiSelectListItemsAndGroupsValueType } from '@developers/scoro-ui';

export type TimeOffDurationValues = ValueOf<typeof TimeOffDuration>;

export type TimeOffData = {
	userSelection: SuiSelectListItemsAndGroupsValueType;
	startDate: TimeOff['startDate'];
	endDate: TimeOff['endDate'];
	type: TimeOff['type']['systemName'];
	reason: string;
	duration: TimeOffDurationValues;
	amountTime: string;
};

type ExtendedTimeOffType =
	TimeOffListPopoverQuery['UserTimeOffList'][0]['timeOff'] & {
		hasMultipleUsers: TimeOffListPopoverQuery['UserTimeOffList'][0]['hasMultipleUsers'];
	};

export type UserTimeOffs = {
	timeOffs?: Array<ExtendedTimeOffType>;
	user: TimeOffListPopoverQuery['UserTimeOffList'][0]['user'];
	availability: TimeOffListPopoverQuery['UserTimeOffList'][0]['availability'];
};

export const COLUMN_USER = 'user';
export const COLUMN_AVAILABILITY = 'availability';
export const COLUMN_PERIOD = 'period';

export type TimeOffPopoverColumn =
	| typeof COLUMN_USER
	| typeof COLUMN_AVAILABILITY
	| typeof COLUMN_PERIOD;
